

const local = {
  // name: 'ORGA MANAGER',
  name: 'ORGA MANAGER DEV',
  company: 'tristar',
  // apiService: 'http://localhost:8080/',
  s3Url: 'http://localhost:8080/',
  apiService: 'https://api.orga.orgadynamics.com/',
  // s3Url: 'https://tp-dev-gw-images.s3.us-east-2.amazonaws.com/',
  appUrl: 'https://orga.orgadynamics.com/',
  shoptalkUrl: 'http://localhost:3001/shoptalk_authenticate'
};

const dev = {
  name: 'ORGA MANAGER DEV',
  company: 'tristar',
  apiService: 'https://api.orga.orgadynamics.com/',
  s3Url: 'https://tp-dev-gw-images.s3.us-east-2.amazonaws.com/',
  appUrl: 'https://orga.orgadynamics.com/',
  shoptalkUrl: 'https://dev.shoptalk.caba.orgadynamics.com/shoptalk_authenticate'
};

const stage = {
  name: 'ORGA MANAGER STAGE',
  company: 'tristar',
  apiService: 'https://api.stage.caba.orgadynamics.com/',
  s3Url: 'https://tp-dev-gw-images.s3.us-east-2.amazonaws.com/',
  appUrl: 'https://stage.caba.orgadynamics.com/',
  shoptalkUrl: 'https://stage.shoptalk.caba.orgadynamics.com/shoptalk_authenticate'
};

const prod = {
  name: 'TRISTAR ORGA MANAGER PROD',
  company: 'tristar',
  apiService: 'https://api.tristar.caba.orgadynamics.com/',
  s3Url: 'https://tp-dev-gw-images.s3.us-east-2.amazonaws.com/',
  appUrl: 'https://tristar.caba.orgadynamics.com/',
  shoptalkUrl: 'https://tristar.shoptalk.caba.orgadynamics.com/shoptalk_authenticate'
};

let processEnv = local;

switch (process.env.REACT_APP_STAGE) {
  case 'prod':
    processEnv = prod;
    break;
  case 'dev':
    processEnv = dev;
    break;
  case 'stage':
    processEnv = stage;
    break;
  default: break;
}

export default processEnv;